export default __webpack_public_path__ + "static/media/clock.777606f1.svg";